export interface Release { version: string; version_stamp: string }
declare const __MEMOHUB_RELEASE__: Release;

// Build metadata identifies this loaded bundle, even while a newer server is online.
export const loadedRelease: Readonly<Release> = Object.freeze(__MEMOHUB_RELEASE__);

export function parseRelease(value: unknown): Release {
  if (!value || typeof value !== "object") throw new Error("Ungültiger Versionsstand");
  const release = value as Release;
  if (typeof release.version !== "string" || !/^\d+\.\d+\.\d+$/.test(release.version)
    || typeof release.version_stamp !== "string" || !/^\d{14}$/.test(release.version_stamp)) {
    throw new Error("Ungültiger Versionsstand");
  }
  return { version: release.version, version_stamp: release.version_stamp };
}
